const BuilderActions = {
  // Project list actions
  LOADING_PROJECTS: "BUILDER_LOADING_PROJECTS",
  LOADED_PROJECTS: "BUILDER_LOADED_PROJECTS",
  PROJECT_CREATED: "BUILDER_PROJECT_CREATED",
  PROJECT_UPDATED: "BUILDER_PROJECT_UPDATED",
  DELETING_PROJECT: "BUILDER_DELETING_PROJECT",
  PROJECT_DELETED: "BUILDER_PROJECT_DELETED",

  // Chat actions
  LOADING_CHAT: "BUILDER_LOADING_CHAT",
  LOADED_CHAT: "BUILDER_LOADED_CHAT",
  POSTED_MESSAGE: "BUILDER_POSTED_MESSAGE",
  GOT_MESSAGE_RESPONSE: "BUILDER_GOT_MESSAGE_RESPONSE",
  UPDATE_CHAT_MESSAGE: "BUILDER_UPDATE_CHAT_MESSAGE",
  APPROVING_PLAN: "BUILDER_APPROVING_PLAN",
  MESSAGE_ERROR: "BUILDER_MESSAGE_ERROR",
  CLEAR_CHAT: "BUILDER_CLEAR_CHAT",

  // Agent execution actions
  AGENT_SESSION_INIT: "BUILDER_AGENT_SESSION_INIT",
  AGENT_SESSION_LOADED: "BUILDER_AGENT_SESSION_LOADED",
  AGENT_TODO_UPDATE: "BUILDER_AGENT_TODO_UPDATE",
  AGENT_FILE_CHANGE: "BUILDER_AGENT_FILE_CHANGE",
  AGENT_TOOL_CALL: "BUILDER_AGENT_TOOL_CALL",
  AGENT_MESSAGE: "BUILDER_AGENT_MESSAGE",
  AGENT_PLANNING_PROGRESS: "BUILDER_AGENT_PLANNING_PROGRESS",  // Planning phase thinking text
  AGENT_TOKEN_USAGE: "BUILDER_AGENT_TOKEN_USAGE",
  AGENT_COMPLETE: "BUILDER_AGENT_COMPLETE",
  AGENT_ERROR: "BUILDER_AGENT_ERROR",
  AGENT_CLEAR: "BUILDER_AGENT_CLEAR",

  // Connection resilience actions
  LAST_EVENT_ID_UPDATED: "BUILDER_LAST_EVENT_ID_UPDATED",

  // Current project (single project view)
  CURRENT_PROJECT_LOADING: "BUILDER_CURRENT_PROJECT_LOADING",
  CURRENT_PROJECT_LOADED: "BUILDER_CURRENT_PROJECT_LOADED",
  CURRENT_PROJECT_UPDATED: "BUILDER_CURRENT_PROJECT_UPDATED",
  CURRENT_PROJECT_CLEARED: "BUILDER_CURRENT_PROJECT_CLEARED",

  // Project context (UID only, for per-project state isolation)
  SET_CURRENT_PROJECT: "BUILDER_SET_CURRENT_PROJECT",

  // Sources (file tree/editor) actions
  SOURCES_TREE_LOADING: "BUILDER_SOURCES_TREE_LOADING",
  SOURCES_TREE_LOADED: "BUILDER_SOURCES_TREE_LOADED",
  SOURCES_FOLDER_EXPANDED: "BUILDER_SOURCES_FOLDER_EXPANDED",
  SOURCES_SEARCH_LOADING: "BUILDER_SOURCES_SEARCH_LOADING",
  SOURCES_SEARCH_LOADED: "BUILDER_SOURCES_SEARCH_LOADED",
  SOURCES_SEARCH_CLEAR: "BUILDER_SOURCES_SEARCH_CLEAR",
  SOURCES_FILE_OPENED: "BUILDER_SOURCES_FILE_OPENED",
  SOURCES_FILE_CLOSED: "BUILDER_SOURCES_FILE_CLOSED",
  SOURCES_TAB_ACTIVATED: "BUILDER_SOURCES_TAB_ACTIVATED",
  SOURCES_FILE_CONTENT_LOADED: "BUILDER_SOURCES_FILE_CONTENT_LOADED",
  SOURCES_FILE_CONTENT_LOAD_ERROR: "BUILDER_SOURCES_FILE_CONTENT_LOAD_ERROR",
  SOURCES_FILE_CONTENT_CHANGED: "BUILDER_SOURCES_FILE_CONTENT_CHANGED",
  SOURCES_FILE_SAVING: "BUILDER_SOURCES_FILE_SAVING",
  SOURCES_FILE_SAVED: "BUILDER_SOURCES_FILE_SAVED",
  SOURCES_FILE_SAVE_ERROR: "BUILDER_SOURCES_FILE_SAVE_ERROR",
  SOURCES_FILE_EXTERNAL_CHANGE: "BUILDER_SOURCES_FILE_EXTERNAL_CHANGE",
  SOURCES_MARK_FILES_STALE: "BUILDER_SOURCES_MARK_FILES_STALE",
  SOURCES_QUEUE_FILE_CHANGE: "BUILDER_SOURCES_QUEUE_FILE_CHANGE",
  SOURCES_SET_DEBOUNCE_TIMER: "BUILDER_SOURCES_SET_DEBOUNCE_TIMER",
  SOURCES_FLAG_TREE_REFRESH: "BUILDER_SOURCES_FLAG_TREE_REFRESH",
  SOURCES_BATCH_RELOAD_START: "BUILDER_SOURCES_BATCH_RELOAD_START",
  SOURCES_BATCH_RELOAD_COMPLETE: "BUILDER_SOURCES_BATCH_RELOAD_COMPLETE",
  SOURCES_CLEAR_PENDING_CHANGES: "BUILDER_SOURCES_CLEAR_PENDING_CHANGES",
  SOURCES_CLEAR_STALE_FLAG: "BUILDER_SOURCES_CLEAR_STALE_FLAG",
  SOURCES_RESET: "BUILDER_SOURCES_RESET",
  SOURCES_PATH_TOGGLED: "BUILDER_SOURCES_PATH_TOGGLED",
  SOURCES_PATHS_EXPANDED: "BUILDER_SOURCES_PATHS_EXPANDED",
  SOURCES_CLEAR_PROJECT: "BUILDER_SOURCES_CLEAR_PROJECT",

  // Project events actions
  PROJECT_EVENTS_LOADING: "BUILDER_PROJECT_EVENTS_LOADING",
  PROJECT_EVENTS_LOADED: "BUILDER_PROJECT_EVENTS_LOADED",
  PROJECT_EVENT_RECEIVED: "BUILDER_PROJECT_EVENT_RECEIVED",

  // Template actions
  TEMPLATES_LOADING: "BUILDER_TEMPLATES_LOADING",
  TEMPLATES_LOADED: "BUILDER_TEMPLATES_LOADED",
  TEMPLATES_LOAD_ERROR: "BUILDER_TEMPLATES_LOAD_ERROR",
  TEMPLATE_LOADING: "BUILDER_TEMPLATE_LOADING",
  TEMPLATE_LOADED: "BUILDER_TEMPLATE_LOADED",
  TEMPLATE_LOAD_ERROR: "BUILDER_TEMPLATE_LOAD_ERROR",
  TEMPLATE_EXPORTING: "BUILDER_TEMPLATE_EXPORTING",
  TEMPLATE_EXPORTED: "BUILDER_TEMPLATE_EXPORTED",
  TEMPLATE_EXPORT_ERROR: "BUILDER_TEMPLATE_EXPORT_ERROR",
  TEMPLATE_INSTANTIATING: "BUILDER_TEMPLATE_INSTANTIATING",
  TEMPLATE_INSTANTIATED: "BUILDER_TEMPLATE_INSTANTIATED",
  TEMPLATE_INSTANTIATE_ERROR: "BUILDER_TEMPLATE_INSTANTIATE_ERROR",
  TEMPLATE_CLEAR: "BUILDER_TEMPLATE_CLEAR",
  DELETING_TEMPLATE: "BUILDER_DELETING_TEMPLATE",
  TEMPLATE_DELETED: "BUILDER_TEMPLATE_DELETED",
};

export default BuilderActions;
